// @flow
import * as React from 'react';
import { Row, Col } from 'react-bootstrap';
import HelpWrapper from './HelpWrapper';

type Params = {
  context: string,
  organisationId: string
};

type Props = {
  pdfUrl?: string,
  videoUrl?: string,
  params: Params
};

class BookingHeader extends React.Component<Props> {
  render() {
    const { pdfUrl, videoUrl } = this.props;

    return (
      <Row className="booking-header-section">
        <Col xs={3} />
        <Col xs={9}>
          <HelpWrapper
            pdfUrl={pdfUrl}
            videoUrl={videoUrl}
            extraClass="inside-booking-header"
          />
        </Col>
      </Row>
    );
  }
}

export default BookingHeader;



// WEBPACK FOOTER //
// ./src/components/BookingHeader.js